import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class CroppedAsset extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get marginLeft() {
    return get(this, '_margin_left.value', '0px');
  }

  get marginTop() {
    return get(this, '_margin_top.value', '0px');
  }

  get width() {
    return get(this, '_width.value', 'auto');
  }

  get height() {
    return get(this, '_height.value', 'auto');
  }

  get videoAsBanner() {
    return !!get(this, '_video_as_banner.value[0]');
  }

  get youTubeSrc() {
    return get(this, '_iframe_src_youtube.value', '');
  }

  get subtitle() {
    return get(this, '_subtitle.value', '');
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get asset() {
    return get(this, '_asset.value[0].url', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/CroppedAsset.model.js